import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];


export const fetchAsyncGetPONum = createAsyncThunk(
    "/fetchAsyncGetPONum",
    async (data) => {
      try {
        let url = `${API_URL}/organization-expense/getPoNum/${data.moduleId}`;
        const response = await axiosInstance.post(url,data);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
);
export const fetchAsyncSendRequestForTotalPayAmount = createAsyncThunk(
  "/fetchAsyncSendRequestForTotalPayAmount",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/send-request/${data.moduleId}`;
      const response = await axiosInstance.post(url, data?.formData);
     
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncUpdateRequestForTotalPayAmount = createAsyncThunk(
  "/fetchAsyncUpdateRequestForTotalPayAmount",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/update-request/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.put(url, data.formData);

      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncGetAllExpense = createAsyncThunk(
  "/fetchAsyncGetAllExpense",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/get/${data.moduleId}/${data.moduleType}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncApproveTotalPayAmount = createAsyncThunk(
  "/fetchAsyncApproveTotalPayAmount",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/approve/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.put(url, data?.formData);
     
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncRejectTotalPayAmount = createAsyncThunk(
  "/fetchAsyncRejectTotalPayAmount",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/reject/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.put(url, data?.formData);
     
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncUpdateExpense = createAsyncThunk(
  "/fetchAsyncUpdateExpense",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/update/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.put(url, data?.formData);
     
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);


export const fetchAsyncSearchExpenseData = createAsyncThunk(
  "/fetchAsyncSearchExpenseData",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/search/${data?.moduleId}`;
      if (data.value) {
        url = url + `?search=${data.value}&listType=${data.listType}`;
      }
      if (data.startDate && data.endDate && data.value) {
        url = url + `&startDate=${data.startDate}&endDate=${data.endDate}&listType=${data.listType}`;
      }
      if (data.startDate && data.endDate && !data.value) {
        url = url + `?startDate=${data.startDate}&endDate=${data.endDate}&listType=${data.listType}`;
      }
      if (data.listType && !data.value && !data.startDate && !data.endDate) {
        url = url + `?listType=${data.listType}`;
      }
     
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncDeleteOrgExpense = createAsyncThunk(
  "/fetchAsyncDeleteOrgExpense",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/delete/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.delete(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncDeleteExpensePdf = createAsyncThunk(
  "/fetchAsyncDeleteExpensePdf",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/delete-pdf/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.post(url,{ key: data.key,spId:data?.spId });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
export const fetchAsyncDeletePaymentListItem = createAsyncThunk(
  "/fetchAsyncDeletePaymentListItem",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/delete-payment-list-item/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.post( url,{listIndex:data?.listIndex });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
export const fetchAsyncDeleteGstListItem = createAsyncThunk(
  "/fetchAsyncDeleteGstListItem",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/delete-gst/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.delete( url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncDeleteRefundListItem = createAsyncThunk(
  "/fetchAsyncDeleteRefundListItem",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/delete-refund-list-item/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.post( url,{listIndex:data?.listIndex });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncDeleteTdsListItem = createAsyncThunk(
  "/fetchAsyncDeleteTdsListItem",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/delete-tds-list-item/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.post( url,{listIndex:data?.listIndex });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);


export const fetchAsyncHardDeleteExpense = createAsyncThunk(
  "/fetchAsyncHardDeleteExpense",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/hard-delete/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.delete(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);


export const fetchAsyncGetExpenseBarChartData = createAsyncThunk(
  "/fetchAsyncGetExpenseBarChartData",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/bar-chart-data/${data?.moduleId}`;
      const response = await axiosInstance.post(url,data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        throw new Error("Token Expire Please Login again!");
      } else {
        throw new Error(error.response.data.message);
      }
    }
  }
);

export const fetchAsyncUploadExpenseInvoice = createAsyncThunk(
  "/fetchAsyncUploadExpenseInvoice",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/upload-invoice/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.post(url, data.formData);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncAddInvoiceRemark = createAsyncThunk(
  "/fetchAsyncAddInvoiceRemark",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/invoice-remark/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.put(url, data.remarkData);

      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncExpenseXlsxData = createAsyncThunk(
  "/fetchAsyncExpenseXlsxData",
  async (data) => {
    try {
      let url = `${API_URL}/organization-expense/xlsx/${data?.moduleId}`;
     
      
      if (data?.role && data.startDate && data.endDate) {
        url = url + `?role=${data.role}&startDate=${data.startDate}&endDate=${data.endDate}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
const AllExpenseSlice = createSlice({
  name: "expenseData",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncGetAllExpense.pending]: (state) => {},
    [fetchAsyncGetAllExpense.fulfilled]: (state, { payload }) => {
      return payload;
    },
    [fetchAsyncSearchExpenseData.pending]: (state) => {},
    [fetchAsyncSearchExpenseData.fulfilled]: (state, { payload }) => {
      return payload;
    },
  },
});

export const getAllOrganizationExpense = (state) => state.expenseData;

export default AllExpenseSlice.reducer;